<template>
  <Module
    :id="selectionData.conf.id"
    :isLoaded="$store.getters.getLvl3Loaded"
  >
    <template>
      <div class="present">
        <ul class="present__list">
          <slot v-if="$store.getters.getSelectedItem.data !== null && $store.getters.getSelectedItem.data.type === 'level_3' && $store.getters.getSelectedItem.data.products.length > 0">
            <ModulePresentItem
              v-for="(product, index) in $store.getters.getSelectedItem.data.products"
              :key="product.product"
              :product="product"
              :index="index"
              :id="product.id"
              :photo="{ src: product.photos[$store.getters.groupAbb][0].original, alt: product.name }"
              :name="product.name"
              :description="productDetailStringBold1(product)"
              :price="{ netto: getPriceLevel3ForGroup(product, $store.getters.getUserGroupId, true), brutto: getPriceLevel3ForGroup(product, $store.getters.getUserGroupId, false) }"
              :stock="product.stock_quantity"
            />
          </slot>

          <li v-else>
            <EmptyDataset title="Keine Delikatessen ausgewählt">
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M16.361 16.353L19.013 23.247 20.604 20.596 23.256 19.005 16.361 16.353z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M23.256 23.247L20.604 20.596" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M.756,3.747a3,3,0,0,1,3-3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M3.756,20.247a3,3,0,0,1-3-3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.256.747a3,3,0,0,1,3,3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M20.256 12.747L20.256 8.247" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M0.756 12.747L0.756 8.247" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M8.256 0.747L12.756 0.747" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M8.256 20.247L12.756 20.247" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
              </template>
              <template v-slot:content>
                <p>Hier wird Ihre Auswahl angezeigt, sobald Sie erste Artikel hinzugefügt haben.</p>
              </template>
            </EmptyDataset>
          </li>

          <ModulePresentItem
            :photo="{ src: 'https://cdn.componata.de/img/box.7c700f33.jpg', alt: 'Componata Präsentbox' }"
            name="Edle Geschenkverpackung mit Magnetverschluss"
            description="Enthaltene Leistungen: <ul><li>Liebevolles Verpacken (⌀20 Minuten)</li><li>Hochwertige Präsentbox</li></li><li>Stilvoller Magnetverschluss</li><li>Dekoratives, nachhaltiges Füllmaterial</li></ul>"
            :price="{ netto: humanPrice(getPriceBoxRawForGroup($store.getters.getUserGroupId, false)), brutto: splittedTaxSingle(getPriceBoxRawForGroup($store.getters.getUserGroupId, false)) }"
          />
        </ul>
      </div>
    </template>
  </Module>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import Module from '@/components/Composer/Module';
import ModulePresentItem from '@/components/Composer/ModulePresentItem';
import EmptyDataset from '@/components/Common/EmptyDataset';

export default {
  name: 'ModulePresent',
  props: ['selectionData'],
  mixins: [logicMixin],
  components: {
    Module,
    ModulePresentItem,
    EmptyDataset
  }
};
</script>

<style lang="scss" scoped>
/**
 * Present Module
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present's tab content
 * @since 2021-08-17
**/

$component: 'present';
$listVerticalSpace: map-get($spacers, 1) * 2.8;

.#{$component} {
  &__list {
    @include unlist;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
